import React from 'react';
import ContactUs from '../ContactUs/ContactUs';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './Contact.css';

const Contact = () => {
    return (
        <div>
            <ContactUs></ContactUs>
            <Footer></Footer>
        </div>
    );
};

export default Contact;